import React from "react";
import { Typography, Space, Input, Row, Col, Flex } from "antd";
import "./index.css";
import { LLFormatWithTime } from "../../../shared";
import { CitiesInput } from "../../input";
import { CheckCircleOutlined } from "@ant-design/icons";

const { Text } = Typography;
const PrintPrescribeMedicine = ({ state, medicinesLookup }) => {
  return (
    <div className="dflex">
      <div className="w-h">
        <Space className="w-100" direction="vertical" size={2}>
          <Space direction="vertical" size={0} className="w-100">
            <div className="space-between client-info width-100">
              <div className="space-d" style={{ width: "300px" }}>
                <Text>Name</Text>
                <Input size="small" value={state?.name} readOnly />
              </div>
              <div className="space-d" style={{ width: "100px" }}>
                <Text>Age</Text>
                <Input size="small" value={state?.age} readOnly />
              </div>
              <div className="space-d" style={{ width: "270px" }}>
                <Text>Date</Text>
                <Input size="small" value={LLFormatWithTime()} readOnly />
              </div>
            </div>
            {state?.medicines?.map((medicine, index) => (
              <div key={index} className="mt-3 w-100">
                <Row gutter={[16, 16]}>
                  <Col span={12}>
                    • <Text>{medicine?.medicineName}</Text>
                  </Col>
                  <Col span={12}>
                    {/* <Input
                      size="small"
                      value={medicine?.notes}
                      readOnly
                      style={{ border: 0 }}
                    /> */}
                    <Text>{medicine?.notes}</Text>
                  </Col>
                </Row>
              </div>
            ))}
          </Space>
        </Space>
      </div>
    </div>
  );
};

export { PrintPrescribeMedicine };
